/* eslint-disable no-unused-vars */
import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

interface SiteDetailData {
  [key: string]: string | number | React.ReactNode;
}

interface SingleTableProps {
  data: SiteDetailData;
  className?: string;
  titleColumnWidth?: string | number;
  valueColumnWidth?: string | number;
  titleColumnStyle?: React.CSSProperties;
  valueColumnStyle?: React.CSSProperties;
  styleTitleCell?: (title: string) => React.CSSProperties;
  styleValueCell?: (
    value: string | number | React.ReactNode,
    title: string
  ) => React.CSSProperties;
}

const SingleTable: React.FC<SingleTableProps> = ({
  className,
  data,
  titleColumnWidth,
  valueColumnWidth,
  titleColumnStyle,
  valueColumnStyle,
  styleTitleCell,
  styleValueCell,
}) => {
  // Convert the data object into an array of [title, value] pairs
  const dataEntries = Object.entries(data);

  return (
    <TableContainer
      component={Paper}
      className={`site-details-table ${className || ""}`}
    >
      <Table aria-label="site details table">
        <TableBody>
          {dataEntries.map(([title, value], index) => {
            const customTitleStyle = styleTitleCell
              ? styleTitleCell(title)
              : {};
            const customValueStyle = styleValueCell
              ? styleValueCell(value, title)
              : {};

            return (
              <TableRow
                key={title}
                sx={{ "&:last-child td, &:last-child th": { border: "none" } }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    fontWeight: "bold",
                    width: titleColumnWidth,
                    backgroundColor: "#f5f5f5",
                    borderRadius:
                      index === 0
                        ? "8px 0 0 0"
                        : index === dataEntries.length - 1
                        ? "0 0 0 8px"
                        : "0",
                    ...titleColumnStyle,
                    ...customTitleStyle,
                  }}
                >
                  {title}
                </TableCell>
                <TableCell
                  sx={{
                    width: valueColumnWidth,
                    borderRadius:
                      index === 0
                        ? "0 8px 0 0"
                        : index === dataEntries.length - 1
                        ? "0 0 8px 0"
                        : "0",
                    ...valueColumnStyle,
                    ...customValueStyle,
                  }}
                >
                  {value}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SingleTable;
